<template>
  <v-card outlined>
    <v-container class="px-1 py-1" fluid>
      <v-card-title class="pt-2 pb-0">
        {{ $t('ELE0028') }}
      </v-card-title>
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-card-text>
          <v-row dense class="py-2">
            <v-col cols="4">
              <ManufacturerInput :label="$t('ELE0134')" v-model="searchCondition.maker" required />
            </v-col>
            <v-col cols="4">
              <ManufacturerInput :label="$t('ELE0048')" v-model="searchCondition.inspMaker" />
            </v-col>
            <v-col cols="4">
              <SelectMultipleInput
                :label="$t('ELE0188')"
                v-model="searchCondition.inspResultCdList"
                :items="inspResultCdList"
                item-text="name"
                item-value="value"
              />
            </v-col>
          </v-row>
          <v-row dense class="py-2">
            <v-col cols="4">
              <PartCodeInput v-if="isEpson" v-model="searchCondition.partCd" :error-messages="errors" />
              <SupplierPartInput v-else v-model="searchCondition.partCd" :supplierCd="''" isSearchByLoginCompany />
            </v-col>
            <v-col cols="4">
              <InspCat1Input v-model="searchCondition.inspCat1" />
            </v-col>
            <v-col cols="4">
              <InspCat2Input v-model="searchCondition.inspCat2" />
            </v-col>
          </v-row>
          <v-row dense align-content="center" class="px-1 py-2">
            <TextFieldInputWithDatePicker :label="$t('ELE0138')" v-model="searchCondition.inspDateFrom" />
            <span class="px-4 py-2"> {{ $t('ELE0141') }} </span>
            <TextFieldInputWithDatePicker :label="$t('ELE0138')" v-model="searchCondition.inspDateTo" />
          </v-row>
          <v-row class="py-2" align="center">
            <v-col>
              <BtnChooseAppDim v-model="inspClassComputed" :value="searchCondition.inspClass" />
            </v-col>
            <v-col class="d-flex justify-end">
              <BtnCsvSearchDownload
                ref="csvDownload"
                fileTitle="inspection_data"
                @search="onClickSearch"
                :disabled="invalid"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </validation-observer>
    </v-container>
  </v-card>
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import { Storage } from '@/plugins/storage.js'
import PartCodeInput from '@/components/atoms/select/PartCodeInput.vue'
import InspCat1Input from '@/components/atoms/select/InspCat1Input.vue'
import InspCat2Input from '@/components/atoms/select/InspCat2Input.vue'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker.vue'
import BtnCsvSearchDownload from '@/components/atoms/button/BtnCsvSearchDownload.vue'
import CompanyInput from '@/components/atoms/select/CompanyInput.vue'
import BtnChooseAppDim from '@/components/atoms/button/BtnChooseAppDim.vue'
import BtnSearch from '@/components/atoms/button/BtnSearch.vue'
import moment from 'moment'
import { InspClassCd, InspResultCd } from '@/enum'
import ManufacturerInput from '@/components/atoms/select/ManufacturerInput.vue'
import SupplierPartInput from '@/components/atoms/select/SupplierPartInput.vue'
import SelectMultipleInput from '@/components/atoms/base/select/SelectMultipleInput'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'ExportInspDataForm',
  mixins: [APIUtils, Message, Loading, DateUtils],
  components: {
    PartCodeInput,
    InspCat1Input,
    InspCat2Input,
    TextFieldInputWithDatePicker,
    BtnCsvSearchDownload,
    CompanyInput,
    BtnChooseAppDim,
    BtnSearch,
    ManufacturerInput,
    SupplierPartInput,
    SelectMultipleInput,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      searchCondition: {
        partCd: '',
        inspCat1: '',
        inspCat2: '',
        maker: '',
        inspMaker: '',
        inspDateFrom: moment().day(-7).format('YYYY-MM-DD'),
        inspDateTo: moment().day(6).format('YYYY-MM-DD'),
        inspClass: InspClassCd.APP,
        inspResultCdList: [],
      },
      inspDataList: [],
    }
  },
  computed: {
    inspResultCdList: {
      get() {
        // プルダウン選択肢をenumから生成
        return Object.values(InspResultCd).map((item) => {
          return { name: item + ': ' + this.$t(`InspResultCd.${item}`), value: item }
        })
      },
    },
    inspClassComputed: {
      get() {
        return this.searchCondition.inspClass
      },
      set(value) {
        this.searchCondition.inspClass = value
      },
    },
    isEpson: {
      get() {
        return this.$store.getters.isEpson
      },
    },
  },
  methods: {
    async onClickSearch() {
      this.startLoading()
      try {
        if (moment(this.searchCondition.inspDateFrom).add(1, 'y') <= moment(this.searchCondition.inspDateTo)) {
          this.setErrorMessage(this.$t('MSG0100'))
          return
        }
        const params = {
          ...this.searchCondition,
          userCompanyCd: this.$store.getters.companyCd,
        }
        const filePath = await API.get('/inspIndex/inspIndexes/file', params)
        Storage.downloadFile(filePath)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0164') })))
      } finally {
        this.stopLoading()
      }
    },
  },
  mounted() {
    if (this.$store.getters.canOQCOnly) {
      this.searchCondition.maker = this.$store.getters.companyCd
      this.searchCondition.inspMaker = this.$store.getters.companyCd
    }
  },
}
</script>
